<!-- ResetPassword.vue -->
<template>
	<div class="container mt-5">
		<h2>Reset Password</h2>
		<form @submit.prevent="resetPassword">
			<PasswordWithRequirements
				v-model="newPassword"
				label="New Password"
				@valid="passwordValid = $event" />
			<PasswordInput v-model="confirmPassword" label="Confirm Password" />
			<button type="submit" class="btn btn-primary">Submit</button>
		</form>
		<div v-if="message" class="mt-3 alert" :class="messageClass">
			{{ message }}
		</div>
	</div>
</template>

<script setup>
	import { ref } from "vue"
	import { useRoute } from "vue-router"
	import PasswordInput from "@/components/PasswordInput.vue"
	import PasswordWithRequirements from "@/components/PasswordWithRequirements.vue"

	const route = useRoute()
	const newPassword = ref("")
	const confirmPassword = ref("")
	const message = ref("")
	const messageClass = ref("")
	const passwordValid = ref(false)

	const resetPassword = async () => {
		if (!passwordValid.value) {
			message.value = "Password does not meet requirements."
			messageClass.value = "alert-danger"
			return
		}
		if (newPassword.value !== confirmPassword.value) {
			message.value = "Passwords do not match."
			messageClass.value = "alert-danger"
			return
		}

		try {
			const response = await fetch(
				`/api/reset-password/${route.params.token}`,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({ password: newPassword.value }),
				}
			)
			const result = await response.json()
			if (response.ok) {
				message.value = "Your password has been reset successfully."
				messageClass.value = "alert-success"
			} else {
				message.value = result.error || "An error occurred. Please try again."
				messageClass.value = "alert-danger"
			}
		} catch (error) {
			message.value = "An error occurred. Please try again."
			messageClass.value = "alert-danger"
		}
	}
</script>
